export const version = {
  hash: 'f7ff9b87',
};
